__turbopack_context__.v({
  "hidden": "Iframe-module__ELeHxq__hidden",
  "iframe": "Iframe-module__ELeHxq__iframe",
  "shimmer": "Iframe-module__ELeHxq__shimmer",
  "skeleton": "Iframe-module__ELeHxq__skeleton",
  "wrapper": "Iframe-module__ELeHxq__wrapper",
});
